import * as URL from "../helpers/Constants";
import axios from "axios";

export default class GlobalAccountService {
    static getGlobalAccountList = params => {
        return axios.get(URL.GET_GLOBAL_ACCOUNT_LIST,
            { ...GlobalAccountService.getAuthHeader(), params });
    }

    static getGlobalAccountById = id => {
        return axios.get(`${URL.GET_GLOBAL_ACCOUNT_BY_ID}/${id}`, GlobalAccountService.getAuthHeader());
    }

    static addGlobalAccount = data => {
        return axios.post(URL.ADD_GLOBAL_ACCOUNT,
            data, GlobalAccountService.getAuthHeader());
    }

    static editGlobalAccount = (id, data) => {
        return axios.put(`${URL.EDIT_GLOBAL_ACCOUNT}/${id}`,
            data, GlobalAccountService.getAuthHeader());
    }

    static deleteGlobalAccount = id => {
        return axios.delete(`${URL.DELETE_GLOBAL_ACCOUNT}/${id}`, GlobalAccountService.getAuthHeader());
    }

    static getAuthHeader = () => {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = { headers: { "Authorization": `Bearer ${accessToken}` } }
        return options;
    }
}
